const GA_MEASUREMENT_ID = "G-7JY992M561"

declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

function gtag(...args: unknown[]): void {
  window.dataLayer.push(args)
}

// Skipped outside production builds (pnpm dev) so local development doesn't
// pollute Analytics with dev-server sessions. Preview deploys (Cloudflare
// Pages branch previews) run the same production build as the real site, so
// those are still tracked — same tradeoff as lib/clarity.ts.
export function initGoogleAnalytics(): void {
  if (!import.meta.env.PROD) return
  window.dataLayer = window.dataLayer || []
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)
  gtag("js", new Date())
  // send_page_view disabled here — this is a client-side-routed SPA, so the
  // automatic pageview from `config` would only ever fire once (on initial
  // load). Page views are instead sent explicitly per route change, see
  // trackPageView / AnalyticsPageViewTracker.
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: false })
}

export function trackPageView(path: string): void {
  if (!import.meta.env.PROD) return
  gtag("event", "page_view", { page_path: path })
}

// Custom event, e.g. for the login funnel (login_started/login_completed) or
// favorite-list actions.
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!import.meta.env.PROD) return
  gtag("event", name, params)
}
